import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SessionTest from "../components/SessionTest";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useLocation } from "react-router-dom";

export default function MainLayout({ children }) {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  // Don't show navbar/footer on login or signup pages, even if authenticated
  // This prevents navbar flash during login/signup success states
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';

  const layoutClasses = isAuthenticated && !isAuthPage
    ? "min-h-screen bg-gray-100 flex flex-col"
    : "bg-gray-50";

  // Session Test visibility control
  const showSessionTest = process.env.NODE_ENV === 'development' && 
    process.env.REACT_APP_ENABLE_SESSION_TEST === 'true';

  return (
    <div className={layoutClasses}>
      {isAuthenticated && !isAuthPage && <Navbar />}
      <main className="flex-grow px-4">{children}</main>
      {isAuthenticated && !isAuthPage && <Footer />}
      
      {/* Session Test Component - Controlled by environment variable */}
      {showSessionTest && <SessionTest />}
    </div>
  );
}
